class TabNavigation {
    constructor(container) {
      this.container = document.querySelector(container);
      if (!this.container) {
        console.error('Container not found!');
        return;
      }
      this.tabs = this.container.querySelectorAll('.c-tabs-item');
      this.contents = this.container.querySelectorAll('.c-tab-navigation-content');
      this.view_more_links = this.container.querySelectorAll('.read-more-link-with-icon');
      this.activeClass = 'c-tabs-item-active';
      this.hiddenClass = 'c-hidden';
  
      this.init();
    }
  
    init() {
      // Bind click event to each tab
      this.tabs.forEach(tab => {
        tab.addEventListener('click', (e) => this.onTabClick(e, tab));
      });

      if ( this.view_more_links.length > 0 ) {
        this.view_more_links.forEach(link => {
          link.addEventListener('click', (e) => this.onViewMoreClick(e, link));
        });
      }
    }

    onViewMoreClick( e, link ){
      e.preventDefault();
    
      const $link = $(link);
      const $linksList = $link.prev('.linksList');
      if (!$linksList.length) return;
    
      const $span = $link.find('span');
      const $arrow = $link.find('i');
      const isViewMore = $.trim($span.text()) === "View more";
    
      $span.text(isViewMore ? "View less" : "View more");
      $arrow.toggleClass('fa-chevron-down', !isViewMore).toggleClass('fa-chevron-up', isViewMore);
    
      if (!$linksList.data('hiddenItems')) {
        const hiddenItems = $linksList.find('.c-hidden').map((_, item) => $(item).index()).get();
        $linksList.data('hiddenItems', hiddenItems);
        
        const $lastItem = $linksList.find('.c-linkItem-last-item');
        if ($lastItem.length) {
          $linksList.data('lastItemIndex', $lastItem.index());
        }
      }
    
      $.each($linksList.data('hiddenItems'), (_, index) => {
        $linksList.children().eq(index).toggleClass('c-hidden', !isViewMore);
      });
    
      if ($linksList.data('lastItemIndex') !== undefined) {
        const $lastItem = $linksList.children().eq($linksList.data('lastItemIndex'));
        if (isViewMore) {
          $lastItem.removeClass('c-linkItem-last-item');
        } else {
          $lastItem.addClass('c-linkItem-last-item');
        }
      }
    }
    
  
    onTabClick(event, tab) {
      const targetKey = tab.getAttribute('data-tab-item-key');
      this.activateTab(targetKey);
    }
  
    activateTab(key) {
      // Deactivate all tabs
      this.tabs.forEach(tab => tab.classList.remove(this.activeClass));
      this.contents.forEach(content => content.classList.add(this.hiddenClass));
  
      // Activate the clicked tab and its corresponding content
      const activeTab = this.container.querySelector(`[data-tab-item-key="${key}"]`);
      const activeContent = this.container.querySelector(`#links-${key}`);
  
      if (activeTab) activeTab.classList.add(this.activeClass);
      if (activeContent) activeContent.classList.remove(this.hiddenClass);
    }
  }